/**
 * Деньги — целые копейки. Делить на 100 только при выводе, складывать только
 * целыми: `toFixed` в арифметике даёт расхождения в отчёте за месяц, которые
 * потом ищут руками.
 */

/** «6 500 ₽». Копейки округляются к рублю — цены в центре целые. */
export function formatKop(kop: number): string {
  const rub = Math.round(kop / 100);
  return `${groups(rub)} ₽`;
}

/** «6 500,50 ₽» — когда копейки не нулевые и их важно показать (выплаты, отчёты). */
export function formatKopExact(kop: number): string {
  const sign = kop < 0 ? '−' : '';
  const abs = Math.abs(kop);
  const rub = Math.floor(abs / 100);
  const rest = abs % 100;
  const tail = rest ? `,${String(rest).padStart(2, '0')}` : '';
  return `${sign}${groups(rub)}${tail} ₽`;
}

/** «6 500» — без знака валюты, для полей ввода и таблиц. */
export const kopToRubString = (kop: number): string => String(Math.round(kop / 100));

/** Ввод рублей → копейки. Дробная часть отбрасывается на уровне копеек, не рублей. */
export function rubStringToKop(value: string): number | null {
  const normalized = value.replace(/\s| /g, '').replace(',', '.');
  if (!/^\d+(\.\d{0,2})?$/.test(normalized)) return null;
  return Math.round(Number(normalized) * 100);
}

/** Складывать суммы только так: целыми копейками. */
export const sumKop = (values: number[]): number => values.reduce((acc, v) => acc + v, 0);

function groups(n: number): string {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
